import { render, staticRenderFns } from "./ExpandedApps.vue?vue&type=template&id=8922486e&"
import script from "./ExpandedApps.vue?vue&type=script&lang=ts&"
export * from "./ExpandedApps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports